import React from 'react'
import { TextField } from '@mui/material'
import { useField } from 'formik'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'

const DateTimePicker = ({ name, ...otherProps }) => {
  const [field, meta] = useField(name)
  const maxDate = new Date()

  const configDateTimePicker = {
    label: otherProps.label,
    inputFormat: 'dd/MM/yyyy',
    minDate: '01 Jan 2021',
    maxDate: maxDate,
    value: field.value,
    readOnly: otherProps.InputProps.readOnly,
    onChange: value => {
      const event = {
        target: {
          name: name,
          value,
        },
      }
      field.onChange(event)
    },
  }

  const configTextField = {
    name: otherProps.name,
    variant: 'outlined',
  }

  if (meta && meta.error) {
    configTextField.error = true
    configTextField.helperText = meta.error
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        {...configDateTimePicker}
        renderInput={params => {
          return <TextField {...configTextField} {...params} fullWidth />
        }}
      />
    </LocalizationProvider>
  )
}
export default DateTimePicker
